exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "i:before{content:\"v\";font-family:ieo}i.i-info{color:#d8d8d8}footer.app-footer{width:100%;background:#1a1a1a;display:flex}footer.app-footer.app-state{display:none}footer.app-footer .fixed-content-container{padding:20px 0;align-items:center}footer.app-footer .fixed-content-container p{color:#777;text-align:center}footer.app-footer .fixed-content-container p:after{content:\"|\";padding:0 10px}footer.app-footer .fixed-content-container a{color:#aeb0b3}footer.app-footer .fixed-content-container a:hover{color:#f0f0f0}footer.app-footer .fixed-content-container a.terms:after{content:\"|\";padding:0 10px}@media (max-width:600px){footer.app-footer .fixed-content-container{flex-direction:column-reverse;align-items:center}footer.app-footer .fixed-content-container p:after{display:none}footer.app-footer .fixed-content-container a{margin-bottom:10px}footer.app-footer .fixed-content-container a.terms:after{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/view/footer/Footer.scss
// module id = 46
// module chunks = 15